const VLIBRAS_ACCESS_POPUP_FALLBACK =
    'https://vlibras.gov.br/app/assets/access_popup.jpg?v=20260510';

function isVlibrasPortalAccessPopupUrl(value: string): boolean {
    const v = value.trim();
    return (
        v.includes('access_popup') &&
        /cdn\.jsdelivr\.net\/gh\/spbgovbr-vlibras\/vlibras-portal/i.test(v)
    );
}

let shimInstalado = false;

export function instalarShimAssetsVlibrasJsdelivr(): void {
    if (shimInstalado || typeof document === 'undefined') {
        return;
    }
    shimInstalado = true;

    try {
        const proto = HTMLImageElement.prototype;
        const desc = Object.getOwnPropertyDescriptor(proto, 'src');
        if (desc?.set && desc?.get) {
            const origSet = desc.set;
            const origGet = desc.get;
            Object.defineProperty(proto, 'src', {
                configurable: true,
                enumerable: desc.enumerable,
                get(this: HTMLImageElement) {
                    return origGet.call(this);
                },
                set(this: HTMLImageElement, value: string) {
                    const next =
                        typeof value === 'string' && isVlibrasPortalAccessPopupUrl(value)
                            ? VLIBRAS_ACCESS_POPUP_FALLBACK
                            : value;
                    origSet.call(this, next);
                },
            });
        }
    } catch {
    }

    try {
        const origSetAttribute = Element.prototype.setAttribute;
        Element.prototype.setAttribute = function (this: Element, qualifiedName: string, value: string) {
            if (
                this instanceof HTMLImageElement &&
                qualifiedName.toLowerCase() === 'src' &&
                typeof value === 'string' &&
                isVlibrasPortalAccessPopupUrl(value)
            ) {
                return origSetAttribute.call(this, qualifiedName, VLIBRAS_ACCESS_POPUP_FALLBACK);
            }
            return origSetAttribute.call(this, qualifiedName, value);
        };
    } catch {
    }

    try {
        const origFetch = window.fetch.bind(window);
        window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
            let url = '';
            if (typeof input === 'string') {
                url = input;
            } else if (input instanceof Request) {
                url = input.url;
            } else {
                url = String(input);
            }
            if (url && isVlibrasPortalAccessPopupUrl(url)) {
                return origFetch(VLIBRAS_ACCESS_POPUP_FALLBACK);
            }
            return origFetch(input, init);
        };
    } catch {
    }
}
